import { useState, type FormEvent } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '综艺', to: '/category/variety' },
  { label: '专题', to: '/topic/deep-night-suspense' },
  { label: '关于', to: '/about' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const submitSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) return;
    setMenuOpen(false);
    navigate(`/search?q=${encodeURIComponent(value)}`);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="flex items-center gap-6 h-16 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="flex items-center justify-center w-9 h-9 rounded-md bg-primary-500 text-background-50">
            <i className="ri-play-circle-fill text-xl"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">
            免费在线观看
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 flex-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                  isActive
                    ? 'text-primary-600 font-medium bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={submitSearch} className="hidden md:flex items-center ml-auto shrink-0">
          <div className="relative w-56 lg:w-72">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-400"></i>
            <input
              type="text"
              name="nav-search"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索电影、电视剧、综艺"
              className="w-full pl-9 pr-3 py-2 text-sm rounded-md bg-background-100 border border-background-200 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent"
            />
          </div>
        </form>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setMenuOpen((prev) => !prev)}
          className="md:hidden flex items-center justify-center w-10 h-10 rounded-md text-foreground-800 hover:bg-background-100 ml-auto cursor-pointer"
        >
          <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 animate-fade-in">
          <form onSubmit={submitSearch} className="mb-3">
            <div className="relative w-full">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-400"></i>
              <input
                type="text"
                name="mobile-search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索电影、电视剧、综艺"
                className="w-full pl-9 pr-3 py-2.5 text-sm rounded-md bg-background-100 border border-background-200 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
            </div>
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm rounded-md transition-colors cursor-pointer ${
                    isActive
                      ? 'text-primary-600 font-medium bg-primary-50'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}